import React from 'react';
import { ChatList } from '../../components/ChatList';
import AdminLayout from '../../components/AdminLayout';

const ChatPage: React.FC = () => {
    return (
        <AdminLayout>
            <div className="p-6">
                <h1 className="text-2xl font-bold text-[#0e1b38] mb-6">Chats</h1>
                <ChatList />
            </div>
        </AdminLayout>
    );
};

export default ChatPage;
